import gql from "graphql-tag";

const GET_BLOGS_BY_CATEGORY = gql`
    query Blogs($category: String!){
        blogs(limit:10, sort:"createdAt:desc", where: { blog_categories: { category: $category } }){
            id,
            title,
            content,
            createdAt
            description
            author{
                name
            }
            preview{
                url
                formats
            }
        }
    }
`
export default GET_BLOGS_BY_CATEGORY